import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 16px;
  background: #fff;
`;

export const DadosSignatario = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px 16px;
  margin-bottom: 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #f7f7f7;

  strong {
    font-size: 14px;
    color: #333;
  }

  span {
    font-size: 14px;
    color: #555;
  }
`;

export const ContratoTexto = styled.div`
  width: 100%;
  max-width: 800px;
  max-height: 45vh;
  overflow-y: auto;
  padding: 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
`;

export const Rodape = styled.div`
  width: 100%;
  max-width: 800px;
  padding: 16px 0;
`;
